import React from "react";
import { Fade } from "@mui/material";
import { ModalsStyles } from './Modals.styles';
import Modal from '../../../components/Modal/Modal';
// Modales
import ModalMovimientos from "../../../pages/saldos/ModalMovimientos";
import ModalDetalle from "../../../pages/aCobrar/ModalDetalle";
import ModalConfirmar from "../../../pages/pagos/Cobros/ModalConfirmar";
// recoil 
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { formIsOpen, routeInfo, rowSelected } from '../../../recoilState/GlobalState';
import moment from "moment";

export default function TransitionModal(props) {
    const classes = ModalsStyles();
    const isOpen = useRecoilValue(formIsOpen);
    const { row } = useRecoilValue(rowSelected);
    const setFormOpen = useSetRecoilState(formIsOpen);
    const { wordKey: route } = useRecoilValue(routeInfo);
    return (
        <div>
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                className={classes.modal}
                title={route === 'Saldos' ? `Movimientos - ${moment(row.id).format('DD/MM/YYYY')}` : route === 'A Cobrar' ? "Detalle" : ""}
                onClose={() => setFormOpen(false)}
                xxl={true}
                open={row?.id && isOpen}
            >
                {/* <Fade in={isOpen} className={classes.modal}> */}
                    {/* <div className={classes.modal}> */}
                        {/* <div className={classes.paper} style={{width:  route === 'Saldos' ? '90%' : '50%'}}> */}
                            {route === 'Saldos' && <ModalMovimientos props={props} date={moment(row.id).format('YYYY-MM-DD')} />}
                            {route === 'A Cobrar' && <ModalDetalle />}
                            {route === 'Cobros > Ver cobros' && <ModalConfirmar props={props}/>}
                        {/* </div> */}
                    {/* </div> */}
                {/* </Fade> */}
            </Modal>
        </div>
    );
}
